import React from 'react';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import Done from '@material-ui/icons/Done';
import Switch from '@material-ui/core/Switch';


class Permission extends React.Component {

    state = {
        close: this.props.current !== this.props.id
    }

    handleClick = event => {
        const { id } = this.props;
        console.log(id);
        this.props.onClick(id);
    }

    render() {
        const { info, permiso, allroles, id } = this.props;
        const { close } = this.state;
        const roles = permiso && permiso.roles && permiso.roles.length > 0
                    ? permiso
                        .roles
                        .filter((f) => allroles.find((r) => r.id === f) )
                    : []
        if (close) {
            return (
                <div className="flex_full_row ob_permission align_center ob_permission_column" onClick={this.handleClick}>
                    {(roles.length > 0) ? <Done className="c_pea ob_square ob_done" /> : <div className={ (info.requerido ? 'ob_square_req' : 'ob_square')} />}
                    <span className="flex_full_row ob_permission_title">{info.nombre}</span>
                    <ExpandLess />
                </div>
            );
        } else {
            return (
                <div className="flex_full_column ob_permission align_center ob_permission_column ">
                    <div className="flex_auto_row width100 align_center hand">
                        {(roles.length > 0) ? <Done className="c_pea ob_square ob_done" /> : <div className={ (info.requerido ? 'ob_square_req' : 'ob_square')} />}
                        <span className="flex_full_row ob_permission_title ob_permission_title_selected">{info.nombre}</span>
                        <ExpandMore />
                    </div>
                    <div className="flex_auto_row width100 ob_permission_subtitle">
                        {info.descripcion}
                    </div>
                    <div className="flex_auto_row width100 ob_permission_roles">
                        {(allroles && allroles.length > 0) &&
                            allroles.map((r, index) => <div key={"permision" + id + "-" + index} className="flex_auto_row align_center">
                                <Switch
                                    name={"permision" + id + "-" + index}
                                    checked={permiso && permiso.roles && !!permiso.roles.find((f) => f === r.id)}
                                    onChange={() => this.props.onCheck(id, r.id)}
                                    value="saved"
                                    color="primary"
                                />
                                {
                                    r.nombre
                                }
                            </div>
                            )
                        }
                    </div>
                </div>
            );
        }
    }
}

export default Permission;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/permission.js